__turbopack_context__.v({
  "focusKeyboardWithinOutline": "mkWVPa_focusKeyboardWithinOutline",
  "focusOutline": "mkWVPa_focusOutline",
  "focusWithinOutline": "mkWVPa_focusWithinOutline",
  "resetFocusOutline": "mkWVPa_resetFocusOutline",
});
